import React, { useState, useEffect } from "react";
import StartAssessment from "./startassessment";
import TakeAssessment from "./takeassessment"
import { useDispatch, useSelector } from "react-redux";
import {
    Startassesment
} from "../../../../Redux/action/quizAction";




function useDisableKeys() {
  useEffect(() => {
    const blockedKeys = [
      "Escape",
      "F12",
      "I",
      "J",
      "C",
      "U"
    ];

    const handleKeyDown = (e) => {
      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (
        (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
        (e.ctrlKey && e.key.toUpperCase() === "U")
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);
}

const assessmentData = {
  title: "Final Exam - Biology 101",
  code: "BIO101-FINAL-2025",
  course: "Biology 101",
  startDate: "2025-06-05T00:00:00Z",
  endDate: "2025-06-10T23:59:59Z",
  passPercentage: 60,
  timeLimitSeconds: 900,
};

export default function AssessmentPage() {
  const dispatch = useDispatch();
  
  const {starttest } =
      useSelector((state) => state.quiz);
  
  const teststart=(value)=>
  {
    dispatch(Startassesment(value))
  }

  useDisableKeys(); 

  return (
    <>
      {starttest==false? (
        <StartAssessment assessmentInfo={assessmentData} onStart={() => teststart(true)} />
      ) : (
        <TakeAssessment />
      )}
    </>
  );
}
